<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>자료실</h2>
            </div>
            <article class="view cmnity">
                <div class="search_box">
                    <p>총 게시물<strong> {{ resourceList.length }}</strong>건</p>
                    <div class="form_inline">
                        <input type="text" class="form_control" placeholder="검색어를 입력하세요." v-model="searchInfo.title">
                        <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                    </div>
                </div>
                <div class="tab_contents">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list">
                                <colgroup>
                                    <col width="80">
                                    <col width="140">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>작성일자</th>
                                        <th>제목</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="resourceList.length == 0">
                                        <td colspan="3"><span>데이터가 없습니다.</span></td>
                                    </tr>
                                    <tr v-for="(item, index) in resourceList" :key="index" @click="fn_move_dtl_page(item.resource_id)">
                                    <td><span>{{ item.no ? item.no : index + 1 }}</span></td>
                                    <td><span>{{ item.reg_dt }}</span></td>
                                    <td class="al">
                                        <span>{{ item.title }}</span>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
                    </div>
                </div>
            </article>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"

export default {
    name: 'ResourceList',
    components: {
      Pagination
    },
    data() {
      return {
        searchInfo : {
            title : '',
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }
        },
        pagingShow : false,
        resourceList: []
      }
    },
    mounted(){
        this.fn_search();
    },
    methods : {
        fn_search(){
            axios
                .post("/api/user/board/getResourceList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.resourceList = res.data.resourceList;

                    console.log("@@@@ resourceList : %o",this.resourceList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;

                    if(this.searchInfo.pageInfo.totPage > 0){
                        this.pagingShow = true;
                    }

                })
                .catch((err) => console.log(err));
        },
        fn_move_dtl_page(resourceId){
          console.log("@@@@@ resourceId : %o",resourceId);
          this.$store.dispatch('detailSearchInfo/setSearchId', resourceId);
          this.$router.push(`/resourceDetail`);
        }
    }
}
</script>